import DateFormatter from "./DateFormatter";

export function getSiteName(){
   return '<span style="font-weight:400 !important;" class="notranslate">my</span><span style="font-weight: bold;" class="notranslate">member.</span><span style="font-weight: 400 !important;" class="notranslate">site</span>';
   // return 'mymember.site';
   // return 'adultmembersites.com';
}
export function getCapitalizeSiteName(){
   return '<span style="font-weight:400 !important;" class="notranslate">my</span><span style="font-weight: bold;" class="notranslate">member.</span><span style="font-weight: 400 !important;" class="notranslate">site</span>';
   // return 'mymember.site';
   // return 'AdultMemberSites.com';
}
export function getSiteLink(){
   return 'https://mymember.site/';
   // return 'https://adultmembersites.com/';
}
export function getSiteTitle(){
   return '<span style="font-weight:400 !important;" class="notranslate">my</span><span style="font-weight: bold;" class="notranslate">member.</span><span style="font-weight: 400 !important;" class="notranslate">site</span>';
   // return 'mymember.site';
   // return 'AdultMemberSites';
}
export function getSiteNameAbbreviatur(){
   return 'MMS';
   // return 'AMS';
}
export function getSiteMediainName(){
   return 'MMSMEDIAIN';
   // return 'AMSMEDIAIN';
}
export function getSupportEmail(){
   return 'support@mymember.site';
}
export function getNoRepliesEmail(){
   return 'no-reply@mymember.site';
}
export function getLegalEmail(){
   return 'legal@mymember.site';
}
export function getNickName(){
   return '@mymember_site';
}
export function getSupportEmailText(){
   return 'support@my<span style="font-weight: bold;">member.</span>site';
}
export const getSiteUrl = () => {
   if(typeof window !== 'object'){
      return '';
   }
   const {
      hostname,
      pathname,
   } = window.location;
   if(hostname === process.env.REACT_APP_AMS_DOMAIN) {
      return `${ hostname }/${ pathname.split('/').filter(Boolean)[0] }`;
   }
   return hostname;
};

export const isHavenMoss = () => {
   if(typeof document !== 'object'){
      return false;
   }
   const node = document.querySelector('meta[name=appKey]');
   let appKey = null;
   if(node) {
      appKey = node.content;
   }
   return 'e6be69d39056494f8da18d9c318a3c6b' === appKey;
}

export function isLocalhost(){
   return Boolean(
      window.location.hostname === 'localhost'
        // [::1] is the IPv6 localhost address.
        || window.location.hostname === '[::1]'
        // 127.0.0.1/8 is considered localhost for IPv4.
        || window.location.hostname.match(
           /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
        || window.location.hostname.match(
           /^192(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
   );
}

export const isStaging = () => {
   return (process.env.REACT_APP_AMS_DOMAIN && process.env.REACT_APP_AMS_DOMAIN.includes('amstest')) ||  window.location.href.includes('amstest');
};

export const getSiteNameHtml = (name = 'member') => {
   return `my<span style="font-weight: bold;">${ name }.</span>site`;
}

export const getAffiliateDisplayHtml = () => {
   return `my.site<span style="font-weight: bold;">affiliate</span>`
}

export const replacePartOfText = (text, searchValue, replaceValue) => {
   return text.replaceAll(searchValue, replaceValue)
}

export const abbreviateNumber = (value) => {
   const isMinus = value < 0
   let newValue = Math.abs(value);
   const suffixes = ["", "K", "M", "B", "T"];
   let suffixNum = 0;
   while(newValue >= 1000) {
      newValue /= 1000;
      suffixNum++;
   }
   let valueString =
       newValue.toString().length > 2
          ? newValue.toPrecision(3)
          : newValue.toPrecision();

   valueString += suffixes[suffixNum];

   const lastIndexNull = valueString.lastIndexOf('0')
   if(lastIndexNull !== 0 && lastIndexNull !== -1) {
      if(valueString[lastIndexNull + 1] && valueString.includes('.') && suffixes.includes(valueString[lastIndexNull + 1])) {
         valueString = valueString.slice(0, lastIndexNull) + valueString.slice(lastIndexNull + 1)
      }
   }
   return isMinus ? `-${ valueString }` : valueString;
}

export const getItalicXHtml = () => {
   return `<span style="font-style: italic;">X</span>`;
}

export const groupTransactionsByTime = (data) => {
   const grouped = {};

   data.forEach(el => {
      // eslint-disable-next-line no-undef
      const timeLabel = DateFormatter.timeWithYearsAgo(el.created_at, _, 'Just now');
      if(!grouped[timeLabel]) {
         grouped[timeLabel] = [];
      }
      grouped[timeLabel].push(el);
   });

   return grouped;
};


export const checkAndDisableConsoleLogOnProduction = () => {
   const isProduction = !isLocalhost() && !isStaging();

   const isNeedToDisableLogging = isProduction && !localStorage.getItem('ENABLE_CONSOLE_LOG')

   if(isNeedToDisableLogging) {
      console.log = function() {};
   }
}

export const isWhiteLabelSite = (siteInfo = {}) => {
   return Boolean(siteInfo?.white_label)
}

export const getIsSafari = () => {
   if(typeof window !== 'object'){
      return false;
   }
   return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
